import styled from "styled-components";
import { borderRadius, fontSizes, fontWeights, spacing, typographyMixin } from "@magicbi/ui-library";
import { rawColors } from "../../../design-system/tokens/colors";

export const Keys = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]};
  white-space: nowrap;
`;

export const Chord = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[0.5]};
`;

export const Separator = styled.span`
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.text.tertiary};
`;

export const Key = styled.kbd`
  display: inline-grid;
  place-items: center;
  min-width: 1.375rem;
  height: 1.375rem;
  padding: 0 ${spacing[1]};
  font-family: inherit;
  ${typographyMixin("caption", 3)}
  color: ${({ theme }) => theme.colors.text.secondary};
  background: ${({ theme }) => theme.colors.surface.secondary};
  border: 1px solid ${({ theme }) => theme.colors.border.stroke};
  border-radius: ${borderRadius.sm};
`;

/** One chip for a whole chord (the default): 11/700, strong text, soft grey fill, light stroke, radius 6. */
export const JoinedKey = styled(Key)`
  min-width: 0;
  height: auto;
  padding: ${spacing[0.5]} ${spacing[1.5]};
  font-size: ${fontSizes["11"]};
  font-weight: ${fontWeights.bold};
  color: ${rawColors.text.strongEmphasis};
  background: ${rawColors.grey[100]};
  border-color: ${rawColors.stroke[200]};
  border-radius: ${borderRadius.md};
`;
